import type { LineupEntry } from "@aura-frontend/omnibus-az-client";

import { mapIPlayerToLineupEntry } from "../utils/api-helpers";
import type { SetupTeam } from "./TeamLineupPanel";

/**
 * A team's lineup for POST game/start: pitcher and catcher (when chosen),
 * then the batting order in slots 1..N.
 */
export const toStartGameLineup = ({
  currentPitcher,
  currentCatcher,
  currentLineup,
}: SetupTeam): LineupEntry[] => [
  ...(Object.keys(currentPitcher).length > 0
    ? [mapIPlayerToLineupEntry(currentPitcher, "pitcher")]
    : []),
  ...(Object.keys(currentCatcher).length > 0
    ? [mapIPlayerToLineupEntry(currentCatcher, "catcher")]
    : []),
  ...currentLineup.map((player, index) =>
    mapIPlayerToLineupEntry(player, index + 1),
  ),
];
